import { render, staticRenderFns } from "./TargetOtherUserDetailModal.vue?vue&type=template&id=35c1e331&lang=pug"
import script from "./TargetOtherUserDetailModal.vue?vue&type=script&lang=ts"
export * from "./TargetOtherUserDetailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports